import { isDeviationPixelArt, isFileLargerThanSize } from '../../../_helpers';
import MediaService from '../../../../utils/DeviationMediaService';
import { useDeviationViewContext } from '../../../../Context';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from '../../../../Duperbrowse/redux/selectors';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import useDeviationDrag from '../../../../Dnd/useDeviationDrag';
import ddt from '@wix/da-ddt';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
export function useImageFile({ width, height, deviation, isZoomed }) {
    const { isLoggedIn } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    const isDuperbrowse = useSelector((state)=>getIsDuperbrowseActive(state));
    const { isFullscreen } = useDeviationViewContext();
    const isPixel = isDeviationPixelArt(deviation);
    const zoomedFile = MediaService.getLargestFullview(deviation);
    const isBiggerThanStage = !!zoomedFile && // must have a fullview
    !MediaService.isGif(deviation) && // must not be a gif as selecting sized one will give you static jpg sometimes
    isFileLargerThanSize(zoomedFile, width, height); // must be larger than the artstage
    const { dragPreview, drag } = useDeviationDrag({
        deviation
    });
    let file;
    // Mobile handling optimises anon traffic for better LCP on slow devices
    if (isMobile) {
        // Duperbrowse & loggedin uses the fullview always
        if (isDuperbrowse || isLoggedIn) {
            file = isBiggerThanStage ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height) : zoomedFile;
        }
        // Anon Canonical uses mobile/small screen selection logic to get the smallest
        // thumb for the artstage but still respect gifs etc this will use fullview if
        // the stage is huge for tablets etc
        if (!isDuperbrowse && !isLoggedIn) {
            file = isBiggerThanStage ? MediaService.getSmallestThumbForArtStage(deviation, width || 360, height || 360) : zoomedFile;
        }
    } else {
        // Desktop handling
        file = isBiggerThanStage ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height) : zoomedFile;
    }
    ddt.log('deviation', 'Using fullview file', file);
    return {
        file,
        zoomedFile,
        isPixel,
        isFullscreen,
        drag: isMobile ? undefined : drag,
        dragPreview: isMobile ? null : dragPreview,
        canZoom: isBiggerThanStage
    };
}
